import React, { PureComponent } from 'react';
import b from 'b_';

import './dataset-item.css';

import { Dataset } from '@interfaces/outreach-entity';
import { formatDate } from 'client/helpers/date';

const class_ = b.with('dataset-item');

interface Props {
    entity: Dataset;
    type: 'horizontal' | 'vertical';
}

export default class DatasetItem extends PureComponent<Props> {
    public render() {
        const { entity, type } = this.props;
        const { title, shortDescription, description, date, link } = entity;

        return (
            <div className={class_({ type })}>
                <a className={class_('title')} href={link}>
                    {title}
                </a>
                <div className={class_('description')}>
                    {shortDescription || description}
                </div>
                <div className={class_('date')}>
                    {formatDate(date)}
                </div>
            </div>
        );
    }
}
